import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "gfu-thumb _mr-2" }
const _hoisted_2 = {
  class: "gfu-media__body",
  "data-qa": "promo-item-copy"
}
const _hoisted_3 = { "format-key": "0" }
const _hoisted_4 = { "format-key": "1" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { "format-key": "0" }
const _hoisted_7 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_image = _resolveComponent("base-image")
  const _component_time_left = _resolveComponent("time-left")
  const _component_localize = _resolveComponent("localize")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_project_promo_item_provider = _resolveComponent("project-promo-item-provider")

  return (_openBlock(), _createBlock(_component_project_promo_item_provider, null, {
    default: _withCtx(({ model, promoItem, project, isVisible }) => [
      isVisible
        ? (_openBlock(), _createBlock(_resolveDynamicComponent($options.getComponent(promoItem.type)), _mergeProps({ key: 0 }, { ..._ctx.$attrs, ...$options.getContextLink(model.contextLink) }, {
            class: ['gfu-media gfu-link--nofx', $options.alignItemClass]
          }), {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_1, [
                _createVNode(_component_base_image, {
                  src: model.image.imageUrl,
                  width: $props.imageSize,
                  height: $props.imageSize,
                  alt: model.image.alt,
                  class: "gfu-thumb__item"
                }, null, 8 /* PROPS */, ["src", "width", "height", "alt"])
              ]),
              _createElementVNode("div", _hoisted_2, [
                (project.phase === _ctx.projectPhases.crowdfunding)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (promoItem.type === _ctx.promoItemTypes.discount)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (!!model.countdown)
                              ? (_openBlock(), _createBlock(_component_localize, {
                                  key: 0,
                                  resource: _ctx.Resources.ProjectHome.ProjectPromoItemTimeLeftForDiscountText
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("strong", _hoisted_3, [
                                      _createVNode(_component_time_left, _normalizeProps(_guardReactiveProps($options.getCountdownProps(model))), null, 16 /* FULL_PROPS */)
                                    ]),
                                    _createElementVNode("strong", _hoisted_4, _toDisplayString(model.discountAmountFormatted), 1 /* TEXT */)
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["resource"]))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(model.countdown) + " " + _toDisplayString(model.label) + " ", 1 /* TEXT */),
                                  _createElementVNode("span", {
                                    innerHTML: _ctx.Resources.format(_ctx.Resources.ProjectHome.ProjectPromoItemDiscountLabel, model.discountAmountFormatted)
                                  }, null, 8 /* PROPS */, _hoisted_5),
                                  _cache[0] || (_cache[0] = _createTextVNode(". ", -1 /* CACHED */))
                                ], 64 /* STABLE_FRAGMENT */))
                          ], 64 /* STABLE_FRAGMENT */))
                        : _createCommentVNode("v-if", true),
                      (promoItem.type === _ctx.promoItemTypes.product)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (!!model.countdown)
                              ? (_openBlock(), _createBlock(_component_localize, {
                                  key: 0,
                                  resource: _ctx.Resources.ProjectHome.ProjectPromoItemTimeLeftForGiftText
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("strong", _hoisted_6, [
                                      _createVNode(_component_time_left, _normalizeProps(_guardReactiveProps($options.getCountdownProps(model))), null, 16 /* FULL_PROPS */)
                                    ])
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["resource"]))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(model.label), 1 /* TEXT */)
                                ], 64 /* STABLE_FRAGMENT */))
                          ], 64 /* STABLE_FRAGMENT */))
                        : _createCommentVNode("v-if", true)
                    ], 64 /* STABLE_FRAGMENT */))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(model.label), 1 /* TEXT */),
                      (promoItem.type === _ctx.promoItemTypes.discount)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            innerHTML: _ctx.Resources.format(_ctx.Resources.ProjectHome.ProjectPromoItemDiscountLabel, model.discountAmountFormatted)
                          }, null, 8 /* PROPS */, _hoisted_7))
                        : _createCommentVNode("v-if", true),
                      _cache[1] || (_cache[1] = _createTextVNode(". ", -1 /* CACHED */))
                    ], 64 /* STABLE_FRAGMENT */)),
                _cache[2] || (_cache[2] = _createTextVNode()),
                _createVNode(_component_tooltip, {
                  text: model.tooltip,
                  "icon-name": "circle-info"
                }, null, 8 /* PROPS */, ["text"])
              ])
            ]),
            _: 2 /* DYNAMIC */
          }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["class"]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}